import {
  documentDirectory,
  getInfoAsync,
  makeDirectoryAsync,
  writeAsStringAsync,
  readAsStringAsync,
  readDirectoryAsync,
  deleteAsync,
} from 'expo-file-system/legacy';

const APP_DATA_FOLDER = documentDirectory + 'AppData/';

// helper to make sure asset subDirectory exists (and create it if it does not exist)
async function ensureDirExists(subDirectory = 'default') {
  const dirInfo = await getInfoAsync(`${APP_DATA_FOLDER}${subDirectory}/`);
  if (!dirInfo.exists) {
    await makeDirectoryAsync(`${APP_DATA_FOLDER}${subDirectory}/`, {
      intermediates: true,
    });
  }
}

export const FileSystemStorage = {
  setItem: async (key: string, value: string, subDirectory = 'default') => {
    await ensureDirExists(subDirectory);
    return await writeAsStringAsync(
      `${APP_DATA_FOLDER}${subDirectory}/${key}`,
      value,
    );
  },

  getItem: async (key: string, subDirectory = 'default') => {
    try {
      return await readAsStringAsync(
        `${APP_DATA_FOLDER}${subDirectory}/${key}`,
      );
    } catch {
      return null;
    }
  },

  removeItem: async (key: string, subDirectory = 'default') => {
    await deleteAsync(
      `${APP_DATA_FOLDER}${subDirectory}/${key}`,
      { idempotent: true }, // don't throw an error if file does not exist
    );
  },

  getAllKeys: async (subDirectory = 'default') => {
    return await readDirectoryAsync(`${APP_DATA_FOLDER}${subDirectory}/`);
  },

  clear: async () => {
    return await deleteAsync(
      `${APP_DATA_FOLDER}`,
      { idempotent: true }, // don't throw an error if folder does not exist
    );
  },
};
